<div class="row" data-testid="login-div">
  <div class="col-xs-2 col-sm-3 col-md-3">
  </div>
  <div class="col-xs-10 col-sm-6 col-md-6">
    <div layout-align="center center" style="display: block; max-width: 450px; text-align: center; margin-left: 30px;">
      <h4 class="form-signin-heading" style="text-align: center; font-family: Candara; font-weight: 300; font-size:34px">
        LOGIN
      </h4>
    </div>
    <div layout-align="center center" style="display: block; border: 1px solid rgb(194, 203, 211); border-radius: 5px; max-width: 450px; text-align: center; margin-left: 30px; margin-top: 20px;">
      <form class="form-signin" name="userLoginForm" data-testid="login-form" [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group">
          <label for="username" class="sr-only">Username</label>
          <input type="text" class="form-control" data-testid="login-form-username" formControlName="username" id="username" placeholder="Username"/>
        </div>
        <div class="form-group">
          <label class="sr-only" for="password">Password</label>
          <input type="password" class="form-control" data-testid="login-form-password" formControlName="password" id="password" placeholder="Password" />
        </div>
        <button [disabled]="loginInProgress" data-testid="login-form-submit" class="btn btn-lg btn-primary btn-block" style="font-family: Candara; font-weight: 800;" type="submit">Submit</button>
      </form>
    </div>
  </div>
  <div class="col-xs-2 col-sm-3 col-md-3">
  </div>
</div>
